/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Store_FishInputs */

const en_store_fish = /** @type {(inputs: Store_FishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fish`)
};

const de_store_fish = /** @type {(inputs: Store_FishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fisch`)
};

/**
* | output |
* | --- |
* | "Fish" |
*
* @param {Store_FishInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const store_fish = /** @type {((inputs?: Store_FishInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_FishInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_store_fish(inputs)
	return en_store_fish(inputs)
});